
import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';


const DualAxisLinechart = React.memo(function DualAxisLinechart({
  showLegend,
  title,
  yAxisTitle,
  yAxisTitleSecond,
  colors,
  data,
  minmax = 0,
  itemDistance = 10,
  logID,
  decimals = 2,
}) {

  const chartData = data.map(
    (item, index) =>
      ({
        ...item,
      
        yAxis: minmax ? (index === 3 ? 1 : 0) : index === 0 ? 0 : 1,
        type: 'area',
        fillColor: 'transparent',
        name: item.marketName,
        data: item.chart.map((chart) => [chart.date, chart.value]),
        lineWidth: 0.8,
        marker: {
          enabled: false,
          symbol: 'circle',
        },
      } )
  );
  const miniMizeValue = chartData.map((item) => item.data).flat();
  const max1 = Math.max(...miniMizeValue.map((item) => item[1]));
  const min1 = Math.min(...miniMizeValue.map((item) => item[1]));

  const options  = {
    chart: {
      type: 'area',
      zoomType: 'x',
      height: 350,
      backgroundColor: 'transparent',
      // spacingRight: 10,
      animation: false,
    },

    credits: {
      enabled: false,
    },
    colors: [...colors],
    title: {
      text: undefined,
    },

    tooltip: {
      valueDecimals: decimals,
      xDateFormat: '%A %b %e %Y',
    },

    xAxis: {
      type: 'datetime',

      dateTimeLabelFormats: {
        day: '%d. %b',
      },
      labels: {
     
        format: "{value:%b'%y}",
        style: {
          textOverflow: 'visible',
          whiteSpace: 'nowrap',
        },
      },
    },
    yAxis: [
      {
        max: minmax ? null : max1,
        min: minmax ? null : min1 - 0.1,
        lineWidth: 0,
        labels: {
          formatter: function formatter() {
            return String(Number(this.value.toFixed(decimals)));
          },
        },
        title: {
          text: yAxisTitle,
          style: {
            fontFamily: "Roboto",
            fontWeight: "500",
            fontSize: "12px",
            lineHeight: "18px",
            color: "black",
          },
        },
      },
      //   second axis
      {
        max: minmax ? null : max1,
        min: minmax ? null : min1 - 0.1,
        opposite: true,
        lineWidth: 0,
        labels: {
          formatter: function formatter() {
            return String(Number(this.value.toFixed(decimals)));
          },
        },
        title: {
          text: yAxisTitleSecond,
          style: {
            fontFamily: "Roboto",
            fontWeight: "500",
            fontSize: "12px",
            lineHeight: "18px",
            color: "black",
          },
        },
      },
    ],

    plotOptions: {
      series: {
        threshold: 1,
        label: {
          connectorAllowed: false,
        },
        animation: false,
      },
    },
    legend: {
   
      enabled: showLegend === false ? false : true,
      align: 'center',
      itemDistance,
      itemMarginBottom: 20,
      symbolPadding: 10,
    },

    time: {
      useUTC: true,
    },

    series: [...chartData],
  };


  return (
    <div >
      {title ? <h3 className="text-center">{title}</h3> : null}
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
});

export default DualAxisLinechart;
